/**
 * Timeouts (ms) for deferring third-party script loading past the critical render path.
 *
 * Used with race(selectHasTier2Data, timer(INTERCOM_DEFER_MS)) or
 * race(selectHasTier2Data, timer(ANALYTICS_DEFER_MS)):
 * - On authenticated routes: Tier2 data or the timeout, whichever comes first
 * - On login/unauthenticated routes: the timeout is the effective trigger
 *
 * Intercom loads first (user-facing chat widget), analytics scripts load later.
 */
export const INTERCOM_DEFER_MS = 2000;
export const ANALYTICS_DEFER_MS = 3000;
